import axios from '@/plugins/axios';

export default {
    namespaced: true,

    actions: {
        async send(ctx, payload) {
            const { data } = await axios.post('/front/forms/send', payload);
            return data;
        },
    }
}
